import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useStateContext } from "../../../../../Context/StateContext";
import ReactSelect from "react-select";
import SpecialitiesFilter from "./AllFilterComponent/SpecialitiesFilter";
import ClearAllorOnebyOne from "./ClearAllorOnebyOne";
import { getFilterwithPosttype } from "../../../../../redux/filter/action";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import IndustryOptionForPosts from "./AllFilterComponent/IndustryOptionForPosts";
import SubcategoryOptionForPosts from "./AllFilterComponent/SubcategoryOptiosForPosts";
import CategoryFilterForPosts from "./AllFilterComponent/CategoryFilterForPosts";
import { useSearchParams } from "react-router-dom";
import PriceFilterBasedonID from "./AllFilterComponent/PriceFilterBasedonID";
import CountryOption from "./AllFilterComponent/CountryOption";

const AllPostFilter = () => {
  const {
    state,
    setSortByTime,
    setSortLanguage,
    setSortPostType,
    locationTypeChange,
    setHiringtype
  } = useStateContext();
  const { sortByTime, sortlanguage, sortposttype, locationType, hiringtype } = state;
  const [filter, setfilter] = useState(false);
  const [searchParams] = useSearchParams();
  const Thetype = searchParams.get('type');
  const filterdata = useSelector(({ filter: { filterdata } }) => filterdata);
  const dispatch = useDispatch();

  const isSelected = (id) => {
    return sortposttype?.some((post) => post.id == id);
  };

  const isSelectedhiringtype = (id) => {
    return Array.isArray(hiringtype) && hiringtype?.some((post) => post.id == id);
  };

  const isSelected2 = (id) => {
    return locationType?.some((post) => post.id == id);
  };
  useEffect(() => {
    if (state?.sortposttype) {
      const ids = sortposttype.map((item) => item.id).join(", ");
      dispatch(getFilterwithPosttype(1, ids || Thetype));
    }
  }, [state?.sortposttype]);



  const renderFilter = (filter) => {
    switch (filter.filter_type) {
      case "2":
        return (
          <div className="filter-cont" key={filter.id}>
            {filter.filter_type && filter.id == 5 && (
              <>
                <h6>{filter?.title}</h6>
                <ReactSelect
                  options={filter.values.map((value) => ({
                    value: value.id,
                    label: value.title,
                  }))}
                  onChange={(selectedOption) => {
                    setSortByTime(
                      [selectedOption]?.map((value) => ({
                        id: value.value,
                        title: value.label,
                      }))
                    );
                  }}
                  value={
                    Array.isArray(sortByTime)
                      ? sortByTime?.map((sort) =>
                        filter.values.find((value) => value.id == sort.id)
                          ? {
                            value: sort.id,
                            label: filter.values.find(
                              (value) => value.id == sort.id
                            )?.title,
                          }
                          : null
                      )
                      : null
                  }
                  placeholder="Select option"
                />
              </>
            )}
            {filter.filter_type && filter.id == 10 && (
              <>
                <h6>{filter?.title}</h6>
                <ReactSelect
                  options={filter.values.map((value) => ({
                    value: value.id,
                    label: value.title,
                  }))}
                  onChange={(selectedOption) => {
                    setSortLanguage(
                      [selectedOption]?.map((value) => ({
                        id: value.value,
                        title: value.label,
                      }))
                    );
                  }}
                  value={
                    Array.isArray(sortlanguage)
                      ? sortlanguage?.map((sort) =>
                        filter.values?.find((value) => value.id == sort.id)
                          ? {
                            value: sort.id,
                            label: filter.values.find(
                              (value) => value.id == sort.id
                            )?.title,
                          }
                          : null
                      )
                      : null
                  }
                  placeholder="Select option"
                />
              </>
            )}
          </div>
        );
      case "3":
        return (
          <div className="filter-cont" key={filter.id}>
            {filter.filter_type && filter.id == 6 && (
              <>
                <h6>{filter?.title}</h6>
                {filter.values.map((value) => (
                  <div className="input-check" key={value.id}>
                    <input
                      type="checkbox"
                      className="form-control"
                      checked={isSelected(value.id)}
                      onChange={() => setSortPostType(value)}
                    />
                    <span>{value.title}</span>
                  </div>
                ))}
              </>
            )}
            {filter.filter_type && filter.id == "60" && (
              <>
                <h6>{filter?.title}</h6>
                {filter.values.map((value) => (
                  <div className="input-check" key={value.id}>
                    <input
                      type="checkbox"
                      className="form-control"
                      checked={isSelectedhiringtype(value.id)}
                      onChange={() => setHiringtype(value)}
                    />
                    <span>{value.title}</span>
                  </div>
                ))}
              </>
            )}
            {filter.filter_type && filter.id == 7 && (
              <>
                <h6>{filter?.title}</h6>
                {filter.values.map((value) => (
                  <div className="input-check" key={value.id}>
                    <input
                      type="checkbox"
                      className="form-control"
                      checked={isSelected2(value.id)}
                      onChange={() => locationTypeChange(value)}
                    />
                    <span>{value.title}</span>
                  </div>
                ))}
              </>
            )}
          </div>
        );
      case "4":
        return (
          <div className="filter-cont" key={filter.id}>
            {filter.filter_type && filter.id == 6 && (
              <>
                <h6>{filter?.title}</h6>
                {filter.values.map((value) => (
                  <div className="input-check" key={value.id}>
                    <input
                      type="radio"
                      className="form-control"
                      checked={isSelected(value.id)}
                      onChange={() => setSortPostType(value)}
                    />
                    <span>{value.title}</span>
                  </div>
                ))}
              </>
            )}
          </div>
        );
      case "5":
        return (
          <div className="filter-cont" key={filter.id}>
            {filter.filter_type && filter.id == "8" && (
              <>
                <div className="filter-cont" key={filter.id}>
                  <h6>{filter?.title}</h6>
                  <IndustryOptionForPosts values={filter.values} filter={filter} />
                </div>
              </>
            )}
            {filter.filter_type && filter.id == "61" && (
              <>
                <div className="filter-cont" key={filter.id}>
                  <h6>{filter?.title}</h6>
                  {/* {JSON.stringify(filter.values)} */}
                  <CountryOption values={filter.values} filter={filter} />
                </div>
              </>
            )}
            {filter.filter_type && filter.id == "48" && (
              <>
                <div className="filter-cont" key={filter.id}>
                  <h6>{filter?.title}</h6>
                  <CategoryFilterForPosts values={filter.values} filter={filter} industries={state?.industries} />
                </div>
              </>
            )}
            {filter.filter_type && (filter.id == "52") && (
              <>
                <div className="filter-cont" key={filter.id}>
                  <h6>{filter?.title}</h6>
                  <SubcategoryOptionForPosts values={filter.values} filter={filter} keywords={state?.keywords} />
                </div>
              </>
            )}
            {filter.filter_type && filter.id == 9 && (
              <>
                <div className="filter-cont" key={filter.id}>
                  <h6>{filter?.title}</h6>
                  <SpecialitiesFilter values={filter.values} />
                </div>
              </>
            )}

          </div>
        );
      case "7":
        return <PriceFilterBasedonID id={filter.id} filter={filter} setfilter={setfilter} />
      // <PriceFilter filter={filter} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <button className="filter-btn" onClick={() => setfilter(true)}>
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/filter.svg`}
          alt=""
        />{" "}
        Filter
      </button>
      <div className={filter ? "filter-sec active" : "filter-sec"}>
        <div className="close-icon">
          <button onClick={() => setfilter(false)}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <ClearAllorOnebyOne setfilter={setfilter} />
        {filterdata.map((filter) => renderFilter(filter))}
      </div>
    </div>
  );
};

export default AllPostFilter;
